import { Box, makeStyles, Typography } from '@material-ui/core';
import LayoutWithPageLoading from 'Components/layout/LayoutWithPageLoading';
import useAsyncTask from 'hooks/useAsyncTask';
import { UserState } from 'Models/Users/@types';
import { OUser } from 'Models/Users/Model';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ReduxStore } from 'stores';
import { TDispatch } from 'Typings/Global';

export interface UserCommentsProps extends RouteComponentProps<{ id: string }> { }
type StoreSelection = Pick<UserState, 'commentList'>;
const UserComments: FC<UserCommentsProps> = ({ match }) => {
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();
    const { commentList } = useSelector<ReduxStore, StoreSelection>(({ Users: { commentList } }) => ({ commentList }));
    const id = match.params['id'];
    const getDataTask = useAsyncTask(async () => dispatch(OUser.getEntityByItem(id, 'comments')));

    useEffect(() => {
        getDataTask.run();
        // eslint-disable-next-line
    }, [id]);
    return (
        <LayoutWithPageLoading loading={getDataTask.status === 'PROCESSING'} assertedItems={[commentList]}>
            {
                commentList?.length ?         
            <Box p={4}>
                <Box pb={2}>
                    <Typography variant="h6">User Comments</Typography>
                </Box>
                {
                  commentList?.map((comment) =>{
                      return(
                        <Box pt={1} pb={1} key={comment?.id} className={classes.commentBlock}>
                            <div dangerouslySetInnerHTML={{__html: comment?.body}} />
                        </Box>
                      )
                  })  
                }
            </Box>
            : 
            <Box pt={4} display={'flex'} justifyContent={'center'} textAlign={'center'}>
                   <Typography variant={'h6'}> No Comment Found</Typography>
            </Box>
            }  
        </LayoutWithPageLoading>
    );
}
const useStyles = makeStyles((theme) => ({
    commentBlock:{
        borderBottom : '1px solid #d9d9d9'
    }
}));
export default UserComments;